import React, { useContext, useState, useEffect } from 'react'
import { useQuery } from 'react-apollo'
import PropTypes from 'prop-types'
import lodash from 'lodash'

import { Context as WorldReadyContext } from '@paypalcorp/worldready-react'
import { MessageFormat } from '@paypalcorp/worldready'

import LocationBasedProductSection from './LocationBasedProductSection'
import getAllVouchers from '../../graphql/getAllVouchers'
import clientData from '../../utils/client-data'

const elmo = clientData.experimentation

export const VoucherSection = ({ showFiltered, storesData, locationName }) => {
  const worldready = useContext(WorldReadyContext)
  const { data, loading } = useQuery(getAllVouchers)

  const [vouchers, setVouchers] = useState([])

  useEffect(() => {
    if (!data || !data.getAllVouchers) return

    const allVouchers = lodash.get(data, 'getAllVouchers.gift_vouchers', [])

    const storeMerchantIDMap = storesData.reduce(
      (map, store) => ({
        ...map,
        [store.merchantId]: store,
      }),
      {},
    )

    const filteredVouchersWithLocation = allVouchers.reduce(
      (_vouchers, voucher) => {
        const matchingStore = storeMerchantIDMap[voucher.merchant_id]
        const voucherWithAddress = {
          ...voucher,
          address: lodash.get(matchingStore, 'address'),
        }

        if (matchingStore) return [..._vouchers, voucherWithAddress]
        return _vouchers
      },
      [],
    )

    const hasFilteredVouchers =
      filteredVouchersWithLocation && filteredVouchersWithLocation.length > 0

    setVouchers(
      showFiltered || hasFilteredVouchers
        ? filteredVouchersWithLocation
        : allVouchers,
    )
  }, [data, storesData])

  if (loading) return null
  if (!vouchers || !vouchers.length) return null
  if (!elmo.localBusinessVouchers) return null

  return (
    <LocationBasedProductSection
      title={new MessageFormat(worldready, {
        id: 'pages/businesses.businesses.local.vouchers.section.title',
      }).format()}
      subtitle={new MessageFormat(worldready, {
        id: 'pages/businesses.businesses.local.vouchers.section.subtitle',
      }).format()}
      buttonContent={null}
      locationName={locationName}
      productList={vouchers}
      displayNameAndAddressCaption={false}
    />
  )
}

VoucherSection.propTypes = {
  showFiltered: PropTypes.bool,
  storesData: PropTypes.array,
  locationName: PropTypes.string,
}

export default VoucherSection
